import { render, staticRenderFns } from "./AcademyHeaderInfo.vue?vue&type=template&id=b9205144&scoped=true&"
import script from "./AcademyHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./AcademyHeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./AcademyHeaderInfo.vue?vue&type=style&index=0&id=b9205144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9205144",
  null
  
)

export default component.exports